<template>
  <div class="head-title">
    <img :src="require('@/assets/images/installDesc/logoWithTitle.png')" class="logo" />
    <img :src="require('@/assets/images/installDesc/title.png')" class="title" />
  </div>
</template>


<script>

export default {
  name: 'InstallDescHeadTitle',
  data() {
    return {
    };
  },
  props: {
    imgSrc: {
    },
  },
  components: {
  },
  computed: {
	},
  watch: {
  },
  mounted() {
	},
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.head-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem 1rem;
  border-bottom: solid 1px #4d4d4d;
  .logo {
    width: 33%;
    display: block;
    margin-bottom: 2rem;
  }
  .title {
    width: 80%;
  }
}
</style>
